import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useWatch } from "react-hook-form";

const UnpassedExams = ({ handleParamChange }) => {
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="disciplineId"
          reference={administrationRequests.getDisciplinesSelect()}
          filter={{ StructuralUnitId: structuralUnitId }}
        >
          <SelectInput
            label="Дисциплина"
            validate={required()}
            emptyText={false}
            onChange={e => handleParamChange("disciplineId", e.target.value)}
          />
        </ReferenceInput>
      )}
    </>
  );
};

export default UnpassedExams;
